module.exports = __webpack_public_path__ + "static/media/logo-innovate.be09df69.png";